var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-doctor-detail',{staticClass:"pt-doctor-detail__withData",attrs:{"detail":_vm.detail,"userId":_vm.userId,"userFullName":_vm.userFullName}})}
var staticRenderFns = []

export { render, staticRenderFns }